import styled from "styled-components";

export const StyledSuccess = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;

  .success-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #ffffffaf;
    box-shadow: 0 0 8px 8px #00000002;
    padding: 48px;
    border-radius: 16px;
    border: 1px solid #e0e0e0;

    h2 {
      font-size: 72px;
      color: var(--orange);
      font-family: "Inter", sans-serif;
      margin-bottom: 8px;
      margin-top: 0;
    }

    p {
      color: var(--dark-grey);
      margin-top: 8px;
    }
  }
`;
